import React from 'react';
import { Badge } from '../ui/badge';
import { Tooltip } from '../ui/Tooltip';
import { 
  FeatherClock, 
  FeatherCalendar, 
  FeatherLayout 
} from '../ui/icons';
import './TaskNotifications.css';

const TaskNotifications = ({ taskId, taskTitle, notification, isLoading }) => {
  if (isLoading) {
    return null; // Don't show loading state for notifications
  }

  if (!notification || !notification.hasNotifications) {
    return null; // Don't show anything if no notifications
  }

  return (
    <div className="task-notifications-compact">
      {notification.workedYesterday && (
        <Tooltip 
          title="Yesterday's Work"
          description={`Worked ${notification.yesterdayHours}h yesterday`}
        >
          <div className="notification-icon yesterday-notification">
            <FeatherClock />
            <span className="notification-count">{notification.yesterdayHours}h</span>
          </div>
        </Tooltip>
      )}
      
      {notification.currentWeekCount > 1 && (
        <Tooltip 
          title="Weekly Activity"
          description={`Worked ${notification.currentWeekCount} times (${notification.currentWeekHours}h) this week`}
        >
          <div className="notification-icon week-notification">
            <FeatherCalendar />
            <span className="notification-count">{notification.currentWeekCount}</span>
            <span className="notification-hours">({notification.currentWeekHours}h)</span>
          </div>
        </Tooltip>
      )}
      
      {notification.allTimeCount > 1 && (
        <Tooltip 
          title="All-time Activity"
          description={`Worked ${notification.allTimeCount} times (${notification.allTimeHours}h) total`}
        >
          <div className="notification-icon alltime-notification">
            <FeatherLayout />
            <span className="notification-count">{notification.allTimeCount}</span>
            <span className="notification-hours">({notification.allTimeHours}h)</span>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default TaskNotifications; 